@for (toast of queue(); track toast.id) {
  <div class="toast" [class.success]="toast.type === ToastType.SUCCESS" [class.error]="toast.type === ToastType.ERROR" animate.enter="enter-animation" animate.leave="exit-animation">
    <div class="content">
      <div class="icon">
        @if (toast.type === ToastType.SUCCESS) {
          <svg-icon src="icons/circle_check.svg" [svgStyle]="{ 'height.px': 32, 'width.px': 32 }"></svg-icon>
        } @else {
          <svg-icon src="icons/error.svg" [svgStyle]="{ 'height.px': 32, 'width.px': 32 }"></svg-icon>
        }
      </div>
      <div class="message">
        <div class="title">{{ toast.title }}</div>
        @if (toast.subtitle) {
          <div class="subtitle">{{ toast.subtitle }}</div>
        }
      </div>
    </div>
    <svg-icon class="close" src="icons/close.svg" [svgStyle]="{ 'width.px':20 }" (click)="removeToast(toast.id)"></svg-icon>
  </div>
}